import { useEffect } from 'react';
import { useRequester } from '../../../../hooks';
import { EikenMaterialResource, type EikenMaterialData } from '../../../../resources';

export function useEikenMaterialList() {
  const fetch = useRequester<EikenMaterialResource[]>({
    onSubmit: () => EikenMaterialResource.fetchMany(),
    onError: console.log,
  });

  useEffect(() => {
    if (fetch.loading) return;
    fetch.submit();
  }, []);

  return {
    items: EikenMaterialResource.list().map((d) => d.data) as EikenMaterialData[],
    count: EikenMaterialResource.list().length,
    isLoading: fetch.loading,
    hasError: !!fetch.error,
    error: fetch.error,
    refetch: fetch.submit,
  };
}
